import Vue from "vue";
import { Component } from "vue-property-decorator";
import $ from "jquery";
import moment from "moment";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalAlerte/modalAlerte";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";

@Component
export default class ModalDevalidationClotureExercice extends Vue {
    public libelleSocieteCourante?: string = "";
    public dateDebutTraitement?: Date = undefined;
    public dateFinTraitement?: Date = undefined;
    public idDerniereCloture: number = 0;
    public motDePasseSaisi?: string = undefined;

    public dataReady = false;

    public societeCourante?: SocieteDto = undefined;
    public isLoadingAnimationVisible = false;

    public init(): void {
        const societe = ParametresInstance.societeCourante;
        if (societe != undefined) {
            this.initSociete();
        }
        EventBus.$on(EventConstants.SOCIETE_CHANGED, (e) => {
            const societe = e as SocieteDto;
            if (societe != undefined) {
                this.initSociete();
            }
        });
        if (!this.dataReady) {
            this.dataReady = true;
        }

        $("#modalDevalidationClotureExercice").modal("show");
    }

    public initSociete(): void {
        this.societeCourante = ParametresInstance.societeCourante;

        if (this.societeCourante == undefined) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "La société active n'a pas été trouvée"
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);

            this.annuler();
        }
        else {
            this.libelleSocieteCourante = this.societeCourante.Libelle;
        }

        ServicesFactoryInstance.ExercicesService.getDernierExerciceCloture(dernierExerciceCloture => {

            if (dernierExerciceCloture == undefined) {
                const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                    message: "Aucun exercice de paie clôturé n'a pas été trouvé"
                });
                EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
                this.annuler();
            }
            else {
                this.dateDebutTraitement = dernierExerciceCloture.DateDebut;
                this.dateFinTraitement = dernierExerciceCloture.DateFin;
                this.idDerniereCloture = dernierExerciceCloture.Id;
                this.$forceUpdate();
            }
        });
    }

    public enregistrer(): void {
        if (this.societeCourante == undefined) {
            return;
        }

        if (this.motDePasseSaisi == undefined || this.motDePasseSaisi == "") {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Merci de saisir le mot de passe journalier."
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);

            return;
        }

        this.dataReady = false;
        this.displayLoadingAnimation(true);

        // Todo : Lancer annulation
        ServicesFactoryInstance.CalculPaieService.devaliderclotureExercice(this.motDePasseSaisi, this.idDerniereCloture, () => {
            EventBus.NavigateTo({ path: "DashBoard" });
            this.displayLoadingAnimation(false);
            $("#modalDevalidationClotureExercice").modal("hide");
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "La dévalidation de la clôture s'est déroulée correctement.",
                callBackYes: () => {
                    window.location.reload(true);
                }
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
        }, () => {
            this.dataReady = true;
            this.displayLoadingAnimation(false);
        });
    }

    public displayLoadingAnimation(shouldDisplay: boolean): void {
        this.isLoadingAnimationVisible = shouldDisplay;
    }

    public annuler(): void {
        this.dataReady = false;

        $("#modalDevalidationClotureExercice").modal("hide");
    }
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalDevalidationClotureExercice/modalDevalidationClotureExercice.ts